/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import useWindowSize from '../../hooks/useWindowSize';

const UserInformation = ({ name, sub, onMenuClick, navButtons, hideUserMenu }) => {
  const { width } = useWindowSize();
  const showUser = width > 1100;

  let userStyle = {};
  if (!onMenuClick) {
    userStyle.right = 30;
  }
  return (
    <React.Fragment>
      {showUser && (
        <div style={{ textAlign: 'right' }}>
          <div className="text-14" style={{ lineHeight: '1em' }}>
            {name || ' '}
          </div>
          {sub && (
            <div className="text-gray text-14" style={{ lineHeight: '1em' }}>
              ({sub})
            </div>
          )}
        </div>
      )}

      <div style={{ display: 'flex', alignItems: 'center' }}>
        {navButtons}
        {!hideUserMenu && onMenuClick && (
          <a
            style={{
              color: '#333',
              fontSize: '1.5em',
              textDecoration: 'none',
              zIndex: 'none',
              marginLeft: 10
            }}
            className="icon-arrow-down5 text-24 cursor-pointer"
            onClick={onMenuClick}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default UserInformation;
